export const PENDING_VERIFICATION_EMAIL_KEY = 'cwy_pending_verification_email';

export const getPendingVerificationEmailStorage = (): string | null => {
  try {
    return sessionStorage.getItem(PENDING_VERIFICATION_EMAIL_KEY);
  } catch {
    return null;
  }
};

export const setPendingVerificationEmailStorage = (email: string): void => {
  try {
    sessionStorage.setItem(PENDING_VERIFICATION_EMAIL_KEY, email);
  } catch {
    // ignore storage errors (private mode, etc.)
  }
};

export const clearPendingVerificationEmailStorage = (): void => {
  try {
    sessionStorage.removeItem(PENDING_VERIFICATION_EMAIL_KEY);
  } catch {
    // ignore
  }
};

/** Backend may return requiresVerification as boolean true. */
export const responseRequiresVerification = (response: unknown): boolean => {
  if (!response || typeof response !== 'object') return false;
  const r = response as Record<string, unknown>;
  return r.requiresVerification === true || r.requiresVerification === 'true';
};

export const getVerificationEmailFromResponse = (
  response: unknown,
  fallbackEmail: string
): string => {
  if (response && typeof response === 'object') {
    const email = (response as Record<string, unknown>).email;
    if (typeof email === 'string' && email.trim()) return email.trim();
  }
  return fallbackEmail.trim();
};
